import * as Highcharts from 'highcharts';

declare function require(moduleName: string): any;

// solid-gauge charts error without this module
require('highcharts/highcharts-more')(Highcharts);
// import all the highcharts modules we use
require('highcharts/modules/data')(Highcharts);
require('highcharts/modules/no-data-to-display')(Highcharts);
require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/map.src')(Highcharts);
require('highcharts/modules/drilldown')(Highcharts);
require('highcharts/modules/funnel')(Highcharts);
require('highcharts/modules/solid-gauge')(Highcharts);

declare module 'highcharts' {
   interface Static {
      maps: {[key:string]: {}};
      Map: Map
   }

   interface Map {
      new (parentId: string, options:{}): ChartObject;
   }
}

import {worldLowres} from './highcharts-world-lowres';

Highcharts.maps['custom/world-lowres'] = worldLowres;

Highcharts['SVGRenderer'].prototype.symbols.dots = function (x, y, w, h) {
   let r = 2; // dot radius
   let s = 10; // space between dots
   return [
      'M', x, y + h*0.5,
      'a', r, r, 0, 1, 1, r*2, 0,
      'a', r, r, 0, 1, 1, -r*2, 0,

      'M', x+s, y + h*0.5,
      'a', r, r, 0, 1, 1, r*2, 0,
      'a', r, r, 0, 1, 1, -r*2, 0,

      'M', x+(s*2), y + h*0.5,
      'a', r, r, 0, 1, 1, r*2, 0,
      'a', r, r, 0, 1, 1, -r*2, 0
   ];
};

Highcharts.setOptions({
   // our datetimes assume local time, this ensures data points will line-up
   // with ticks on the axis
   global: { useUTC: false },
   //colors: ['#115bcb', '#15ca9d', '#00a8ff', '#5f51f5', '#dc3159'],
   chart: {
      style: {
         fontFamily: 'Poppins, sans-serif'
      },
      borderRadius: 4,
      backgroundColor: '#ffffff'
   },
   title: {
      style: {
         // TODO: could set default title text color to a setting value such as '#145ec6'
         color: '#617187'
      }
   },
   credits: {
      enabled: false
   },
   // print is broken in several ways so define a set of export menu items
   exporting: {
      buttons: {
         contextButton: {
            symbol: 'dots',
            symbolStrokeWidth: 2,
            symbolStroke: '#b9bdc6',
            symbolFill: '#b9bdc6',
            symbolX: 12.5,
            width: 34,
            menuItems: [
               {
                  text: 'Download to PNG image',
                  onclick: function () {
                     this.exportChart();
                  }
               },
               {
                  text: 'Download to JPEG image',
                  onclick: function () {
                     this.exportChart({type: 'image/jpeg'});
                  }
               },
               {
                  text: 'Download to SVG vector image',
                  onclick: function () {
                     this.exportChart({type: 'image/svg+xml'});
                  }
               },
               {
                  text: 'Download to PDF file',
                  onclick: function () {
                     this.exportChart({type: 'application/pdf'});
                  }
               }
            ]
         }
      }
   },
});
